import React, { useState } from 'react';
import { FC } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useTranslations from '@hooks/useTranslation';
import { publicAssets } from '@utils/url.utils';
import {
    About,
    Benefit,
    BenefitLabel,
    BenefitNumber,
    Benefits,
    Description,
    Image,
    Label,
    Title,
    Wrapper,
} from './Hero.elements';

export interface HeroProps {
    titleKey: string;
    imageKey: string;
    descriptionKey?: string;
    listKeys?: string[];
    withBenefits?: boolean;
}

const HeroTemplate: FC<HeroProps> = ({ titleKey, imageKey, listKeys, descriptionKey, withBenefits }) => {
    const { t } = useTranslations();

    return (
        <>
            <Wrapper>
                <Image src={publicAssets(`/${imageKey}`)} />
                <About>
                    <Title
                        dangerouslySetInnerHTML={{ __html: t(titleKey) }}
                        withoutBottomPadding={listKeys?.length > 0 && !!descriptionKey}
                    />
                    {descriptionKey && <Description dangerouslySetInnerHTML={{ __html: t(descriptionKey) }} />}
                    {listKeys?.length > 0 &&
                        listKeys?.map((listKey, key) => (
                            <Label key={key}>
                                <IconTemplate name={Icons.CheckThin} />{' '}
                                <span dangerouslySetInnerHTML={{ __html: t(listKey) }} />
                            </Label>
                        ))}
                </About>
            </Wrapper>
            {withBenefits && (
                <Benefits>
                    <Benefit>
                        <BenefitNumber>{t('homepage.benefit1.number')}</BenefitNumber>
                        <BenefitLabel dangerouslySetInnerHTML={{ __html: t('homepage.benefit1.label') }} />
                    </Benefit>
                    <Benefit>
                        <BenefitNumber>{t('homepage.benefit2.number')}</BenefitNumber>
                        <BenefitLabel dangerouslySetInnerHTML={{ __html: t('homepage.benefit2.label') }} />
                    </Benefit>
                    <Benefit>
                        <BenefitNumber>{t('homepage.benefit3.number')}</BenefitNumber>
                        <BenefitLabel dangerouslySetInnerHTML={{ __html: t('homepage.benefit3.label') }} />
                    </Benefit>
                    <Benefit>
                        <BenefitNumber>{t('homepage.benefit4.number')}</BenefitNumber>
                        <BenefitLabel dangerouslySetInnerHTML={{ __html: t('homepage.benefit4.label') }} />
                    </Benefit>
                </Benefits>
            )}
        </>
    );
};

export default HeroTemplate;
